module.exports = __webpack_public_path__ + "static/assets/58aff1c9bfccba0cdd0ad70e3b65eb23.svg";